import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";


@Injectable()
export class InsurersProvider {

  constructor(
    private afs: AngularFirestore
  ) {}

  listInsurers(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/insurers`, ref =>
      ref.orderBy("name", "asc")
    );
  }

  getInsurer(program_id: string, insurer_id: string) {
    return this.afs.collection<any>(`program/${program_id}/insurers/${insurer_id}`);
  }

  addInsurer(program_id: string, insurer: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    insurer = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...insurer };
    return this.afs.collection<any>(`program/${program_id}/insurers`).doc(doc_id).set(insurer);
  }

  updateInsurer(program_id: string, insurer_id, insurer: any, user: any)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    insurer = { updatedAt, updatedBy, ...insurer };
    return this.afs.collection<any>(`program/${program_id}/insurers`).doc(insurer_id).update(insurer);
  }

  deleteInsurer(program_id: string, insurer_id: string)  {
    var batch = this.afs.firestore.batch();
    const docRef = this.afs.doc(`program/${program_id}/insurers/${insurer_id}`).ref;
    batch.delete(docRef);
    return batch.commit();
  }
}



// WEBPACK FOOTER //
// ./src/providers/insurers/insurers.ts